<template>
  <div class="cadastrar-form">
    <breadcrumb :items="breadcrumbItems" />

    <div class="titulo-form">
      <h3>{{ verificarRota() }} Vaga</h3>
    </div>

    <form @submit.prevent="enviar()">
      <div class="form-layout">
        <div class="col-left">
          <div class="field-group">
            <label class="field-label required"
              >Titulo
              <span
                class="help-icon"
                title="Informe o título da vaga"
                >?</span
              ></label
            >
            <input
              type="text"
              class="field-input"
              v-model="form.titulo"
              required
            />
          </div>
          <div class="field-group">
            <label class="field-label required"
              >Local da vaga
              <span
                class="help-icon"
                title="Informe o local onde a vaga será exercida"
                >?</span
              ></label
            >
            <input
              type="text"
              class="field-input"
              v-model="form.localVaga"
              required
            />
          </div>
          <div class="field-group">
            <label class="field-label required"
              >Tipo de Vaga
              <span
                class="help-icon"
                title="Informe se a vaga é agente, remunerada ou estágio"
                >?</span
              ></label
            >
            <div class="tipo-vaga-container">
              <label
                class="tipo-vaga-option"
                :class="{ selected: !form.isBolsistaRemunerado && !form.isEstagiario }"
              >
                <input
                  type="radio"
                  name="tipoVaga"
                  value="VOLUNTARIA"
                  :checked="!form.isBolsistaRemunerado && !form.isEstagiario"
                  @change="setTipoVaga('VOLUNTARIA')"
                />
                <span class="radio-custom"></span>
                Agente
              </label>
              <label
                class="tipo-vaga-option"
                :class="{ selected: form.isBolsistaRemunerado && !form.isEstagiario }"
              >
                <input
                  type="radio"
                  name="tipoVaga"
                  value="REMUNERADA"
                  :checked="form.isBolsistaRemunerado && !form.isEstagiario"
                  @change="setTipoVaga('REMUNERADA')"
                />
                <span class="radio-custom"></span>
                Remunerada
              </label>
              <label
                class="tipo-vaga-option"
                :class="{ selected: form.isEstagiario }"
              >
                <input
                  type="radio"
                  name="tipoVaga"
                  value="ESTAGIO"
                  :checked="form.isEstagiario"
                  @change="setTipoVaga('ESTAGIO')"
                />
                <span class="radio-custom"></span>
                Estágio
              </label>
            </div>
          </div>
          <div id="datas">
            <div class="field-group">
              <label
                for="dataInicio"
                class="field-label required"
                >Data Inicial das Inscrições
                <span
                  class="help-icon"
                  title="Data de início das inscrições para a vaga"
                  >?</span
                ></label
              >
              <input
                type="date"
                id="dataInicio"
                class="field-input"
                :min="dataMinima"
                v-model="form.dataInicioInscricao"
                required
              />
            </div>

            <div class="field-group">
              <label
                for="dataFim"
                class="field-label required"
                >Data Final das Inscrições
                <span
                  class="help-icon"
                  title="Data de encerramento das inscrições para a vaga"
                  >?</span
                ></label
              >
              <input
                type="date"
                id="dataFim"
                class="field-input"
                :min="dataMinima"
                v-model="form.dataFimInscricao"
                required
              />
            </div>
          </div>
          <div class="palavras-chave-form">
            <label class="field-label required"
              >Palavras-chave
              <span
                class="help-icon"
                title="Informe as palavras-chave relacionadas à vaga separadas por vírgula"
                >?</span
              ></label
            >
            <div class="field-group">
              <input
                type="text"
                class="field-input"
                v-model="novaPalavra"
                placeholder="Ex: Estágio, Analista de Sistemas, TI"
                @keydown.enter.prevent="adicionarPalavra"
              />
              <div>
                <button
                  type="button"
                  @click.prevent="adicionarPalavra()"
                >
                  Adicionar
                </button>
              </div>
            </div>
            <div
              v-if="form.tags.length > 0"
              class="keywords-tags"
            >
              <span
                v-for="(palavra, index) in form.tags"
                :key="index"
                class="keyword-tag palavra"
              >
                {{ palavra }}
                <button
                  type="button"
                  class="tag-remove"
                  @click.prevent="removerPalavra(index)"
                >
                  ×
                </button>
              </span>
            </div>
          </div>
          <div class="field-group">
            <label class="field-label required"
              >Link para inscrição
              <span
                class="help-icon"
                title="Informe o link onde os candidatos podem se inscrever"
                >?</span
              ></label
            >
            <input
              type="url"
              class="field-input"
              v-model="form.linkInscricao"
              required
            />
          </div>
          <div
            class="field-group"
            v-if="verificarRota() === 'Editar'"
          >
            <label class="field-label"
              >Status da vaga
              <span
                class="help-icon"
                title="Informe o status atual da vaga"
                >?</span
              ></label
            >
            <select
              class="field-input"
              v-model="form.status"
            >
              <option value="ABERTA">Inscrições Abertas (ABERTA)</option>
              <option value="ENCERRADA">
                Inscrições Encerradas (ENCERRADA)
              </option>
              <option value="CANCELADA">Vaga Cancelada (CANCELADA)</option>
            </select>
          </div>
          <div class="field-group">
            <label class="field-label"
              >Link para edital (Opcional)
              <span
                class="help-icon"
                title="Informe o link do edital da vaga"
                >?</span
              ></label
            >
            <input
              type="url"
              class="field-input"
              v-model="form.linkEdital"
            />
          </div>
          <div class="field-group">
            <label class="field-label"
              >Imagem (Opcional)
              <span
                class="help-icon"
                title="Selecione uma imagem ilustrativa para a vaga"
                >?</span
              ></label
            >
            <div class="file-upload">
              <label
                class="btn-escolher"
                @click="triggerFileInput"
                >Escolher arquivo</label
              >
              <input
                ref="fileInput"
                type="file"
                accept="image/*"
                style="display: none"
                @change="handleFileChange"
              />
              <span class="file-name">{{
                imagemNome || "Nenhum arquivo escolhido"
              }}</span>
            </div>
          </div>

          <div
            v-if="imagemPreview"
            class="image-preview-container"
          >
            <img
              :src="imagemPreview"
              alt="Pré-visualização da imagem"
              class="image-preview-img"
            />
            <button
              type="button"
              class="btn-remover-img"
              @click="removerImagem"
            >
              Remover imagem
            </button>
          </div>

          <div
            class="field-group"
            v-if="imagemSelecionada || imagemPreview"
          >
            <label class="field-label required"
              >Descrição da imagem (Acessibilidade)
              <span
                class="help-icon"
                title="Descreva a imagem para acessibilidade"
                >?</span
              ></label
            >
            <input
              type="text"
              class="field-input"
              v-model="form.descricaoImagem"
              placeholder="Descrição detalhada da imagem"
              :required="Boolean(imagemSelecionada || imagemPreview)"
            />
          </div>
        </div>

        <div class="col-right">
          <div class="field-group full-height">
            <label class="field-label required"
              >Texto informativo
              <span
                class="help-icon"
                title="Informe o texto da notícia"
                >?</span
              ></label
            >

            <textarea
              class="field-input texto-informativo"
              v-model="form.textoInformativo"
              required
            ></textarea>
          </div>
        </div>
      </div>
      <div class="cadastro-form">
        <button type="submit">
          <div v-if="carregando">
            <carregamento :tipoCarregamento="'input'" />
          </div>
          <div v-else>
            {{ mensagemBotao() }}
          </div>
        </button>
      </div>
    </form>
  </div>
  <aviso
    v-if="mostrarModal"
    :texto="mensagemModal"
    :sucesso="sucessoModal"
    @fecharModal="fecharModalAviso"
  />
</template>

<script setup>
import { ref, onBeforeUnmount, computed, onMounted } from "vue";

import { useEditor, EditorContent } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import TextAlign from "@tiptap/extension-text-align";
import Aviso from "@/components/common/aviso.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import { useRoute } from "vue-router";
import vagasService from "@/service/vagasService";
import Carregamento from "@/components/common/Carregamento.vue";
import router from "@/router";

const novaPalavra = ref("");
const mostrarModal = ref(false);
const mensagemModal = ref("");
const sucessoModal = ref(false);
const hoje = new Date();
const dataMinima = ref(hoje.toISOString().split("T")[0]);

const route = useRoute();
const carregando = ref(false);

const fileInput = ref(null);
const imagemPreview = ref(null);
const imagemNome = ref("");
const imagemSelecionada = ref(false);

const breadcrumbItems = computed(() => {
  const acaoId = route.params.id || form.value?.acaoId || form.value?.acao?.id;

  if (acaoId) {
    return [
      { label: "Início", to: "/" },
      { label: "Ações", to: "/suas-acoes" },
      { tipo: "acao", id: acaoId, to: `/acao/${acaoId}` },
      { label: "Vagas", to: `/acao/${acaoId}/vagas` },
      {
        label: verificarRota() === "Editar" ? "Editar vaga" : "Cadastrar vaga",
        to: "",
      },
    ];
  }

  return [
    { label: "Início", to: "/" },
    { label: "Vagas", to: "/vagas" },
    {
      label: verificarRota() === "Editar" ? "Editar vaga" : "Cadastrar vaga",
      to: "",
    },
  ];
});

const form = ref({
    id: "",
    titulo: "",
    localVaga: "",
    isBolsistaRemunerado: false,
    isEstagiario: false,
    remunerada: false,
    tipoVaga: false,
    dataInicioInscricao: "",
    dataFimInscricao: "",
    tags: [],
    linkInscricao: "",
    linkEdital: "",
    textoInformativo: "",
    imagem: {
      mimeType: "",
      base64Data: "",
    },
    descricaoImagem: "",
    status: "ABERTA"
});

function triggerFileInput() {
  if (fileInput.value) {
    fileInput.value.click();
  }
}

function handleFileChange(event) {
  const file = event.target.files[0];
  if (!file) return;

  const nome = file.name;
  const extensao = nome.split(".").pop().toLowerCase();
  const extensoesPermitidas = ["png", "jpg", "jpeg", "webp"];

  if (!extensoesPermitidas.includes(extensao)) {
    mostrarModalAviso("Arquivo não permitido. Use PNG, JPG, JPEG ou WEBP.", false);
    return;
  }

  imagemNome.value = file.name;
  form.value.imagem = {
    mimeType: file.type || `image/${extensao}`,
    base64Data: "",
  };

  const leitor = new FileReader();
  leitor.readAsDataURL(file);
  leitor.onload = () => {
    const result = leitor.result;
    form.value.imagem.base64Data = result.split(",")[1];
    imagemPreview.value = result;
    imagemSelecionada.value = true;
  };
}

function removerImagem() {
  imagemPreview.value = null;
  imagemNome.value = "";
  imagemSelecionada.value = false;
  form.value.imagem = {
    mimeType: "",
    base64Data: "",
  };
  form.value.descricaoImagem = "";
  if (fileInput.value) {
    fileInput.value.value = "";
  }
}

function setTipoVaga(tipo) {
    if (tipo === 'REMUNERADA') {
        form.value.isBolsistaRemunerado = true;
        form.value.isEstagiario = false;
        form.value.remunerada = true;
        form.value.tipoVaga = 'REMUNERADA';
    } else if (tipo === 'ESTAGIO') {
        form.value.isBolsistaRemunerado = false;
        form.value.isEstagiario = true;
        form.value.remunerada = false;
        form.value.tipoVaga = 'ESTAGIO';
    } else {
        form.value.isBolsistaRemunerado = false;
        form.value.isEstagiario = false;
        form.value.remunerada = false;
        form.value.tipoVaga = 'VOLUNTARIA';
    }
}

function adicionarPalavra() {
  const valorLimpo = novaPalavra.value.trim();

  if (!valorLimpo) {
    novaPalavra.value = "";
    return;
  }

  // Separa exclusivamente por vírgula para permitir termos com espaço (ex: "Analista de Sistemas")
  const itens = valorLimpo
    .split(/[;,]+/)
    .map((p) => p.trim())
    .filter((p) => p.length > 0);

  const novasTags = itens.filter((p) => !form.value.tags.includes(p));
  form.value.tags = [...form.value.tags, ...novasTags];
  novaPalavra.value = "";
}

function removerPalavra(index) {
  form.value.tags.splice(index, 1);
}

function verificarRota() {
  let nome = "";

  route.name == "editar-vaga" ? (nome = "Editar") : (nome = "Cadastrar");

  return nome;
}

function mensagemBotao() {
  let mensagem = "";
  verificarRota() == "Editar"
    ? (mensagem = "Confirmar edição")
    : (mensagem = "Cadastrar vaga");

  return mensagem;
}

async function enviar() {
  // Validação de datas: dataInicioInscricao <= dataFimInscricao
  if (form.value.dataInicioInscricao && form.value.dataFimInscricao) {
    const dataInicio = new Date(form.value.dataInicioInscricao);
    const dataFim = new Date(form.value.dataFimInscricao);
    if (dataInicio > dataFim) {
      mostrarModalAviso(
        "A data de início das inscrições não pode ser posterior à data de fim.",
        false
      );
      return;
    }
  }

  // Validação de acessibilidade: descrição da imagem obrigatória se houver imagem carregada/selecionada
  if ((imagemSelecionada.value || imagemPreview.value) && !form.value.descricaoImagem?.trim()) {
    mostrarModalAviso(
      "Por favor, informe a descrição da imagem para acessibilidade.",
      false
    );
    return;
  }

  if (form.value.textoInformativo == "") {
    mostrarModalAviso("Por favor adicione um texto informativo à vaga", false);
    return;
  } else if (form.value.tags.length == 0) {
    mostrarModalAviso(
      "Por favor adicione pelo menos uma palavra-chave à vaga",
      false
    );
    return;
  }

  carregando.value = true;
  try {
    const nomeRota = verificarRota();
    if (nomeRota == "Editar") {
      const response = await editarVaga();
      if (response) {
        mostrarModalAviso("Vaga editada com sucesso!", true);
      } else {
        mostrarModalAviso(
          "Ocorreu um erro ao editar a vaga. Por favor, tente novamente.",
          false
        );
      }
    } else {
      const response = await cadastrarVaga();
      if (response) {
        mostrarModalAviso("Vaga cadastrada com sucesso!", true);
      } else {
        mostrarModalAviso(
          "Ocorreu um erro ao cadastrar a vaga. Por favor, tente novamente.",
          false
        );
      }
    }
  } catch (error) {
    console.error("Erro ao processar a vaga:", error);
    mostrarModalAviso("Ocorreu um erro inesperado ao salvar a vaga.", false);
  } finally {
    carregando.value = false;
  }
}

async function cadastrarVaga() {
  const acaoId = route.params.id || form.value?.acaoId || form.value?.acao?.id;
  const payload = {
    ...form.value,
    isBolsistaRemunerado: form.value.isBolsistaRemunerado,
    isEstagiario: Boolean(form.value.isEstagiario),
    imagem: form.value.imagem?.base64Data ? { ...form.value.imagem } : null,
  };

  const response = await vagasService.postVaga(acaoId, payload);
  return response;
}

async function editarVaga() {
  const payload = {
    ...form.value,
    isBolsistaRemunerado: form.value.isBolsistaRemunerado,
    isEstagiario: Boolean(form.value.isEstagiario),
    imagem: form.value.imagem?.base64Data ? { ...form.value.imagem } : null,
  };
  const vagaId = payload.id;

  const response = await vagasService.updateVaga(vagaId, payload);
  return response;
}

function mostrarModalAviso(mensagem, tipoSucesso = false) {
  mostrarModal.value = true;
  mensagemModal.value = mensagem;
  sucessoModal.value = tipoSucesso;
}

function fecharModalAviso() {
  mostrarModal.value = false;
  if (sucessoModal.value) {
    router.push(`/Vaga/${form.value.id}`);
  }
}

const editor = useEditor({
  content: form.value.textoInformativo,
  extensions: [
    StarterKit,
    Underline,
    TextAlign.configure({
      types: ["heading", "paragraph"],
    }),
  ],
  onUpdate: ({ editor }) => {
    form.value.textoInformativo = editor.getHTML();
  },
});

function parseDate(data) {
  return data.split("T")[0];
}

onMounted(async () => {
  const nomeRota = verificarRota();

  if (nomeRota == "Editar") {
    const vagaId = route.params.vagaId;

    const response = await vagasService.getVagaById(vagaId);
    const vagaEncontrada = response?.data || response;
    form.value = vagaEncontrada;

    if (vagaEncontrada.imagemUrl) {
      imagemPreview.value = vagaEncontrada.imagemUrl;
      imagemSelecionada.value = true;
    }

    if (vagaEncontrada.isEstagiario) {
      setTipoVaga("ESTAGIO");
    } else if (vagaEncontrada.isBolsistaRemunerado) {
      setTipoVaga("REMUNERADA");
    } else {
      setTipoVaga("VOLUNTARIA");
    }

    form.value.dataInicioInscricao = parseDate(form.value.dataInicioInscricao);
    form.value.dataFimInscricao = parseDate(form.value.dataFimInscricao);
  }
});

onBeforeUnmount(() => {
  if (editor.value) {
    editor.value.destroy();
  }
});
</script>

<style scoped>
.cadastrar-form {
  min-height: 700px;
}

.tipo-vaga-container {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  padding: 8px 0;
}

.tipo-vaga-option {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--preto, #333);
  cursor: pointer;
  user-select: none;
  position: relative;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.tipo-vaga-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.radio-custom {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #ccc;
  background-color: white;
  display: inline-block;
  position: relative;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.tipo-vaga-option:hover .radio-custom {
  border-color: var(--roxo-claro, #772fa2);
}

.tipo-vaga-option input[type="radio"]:checked + .radio-custom {
  border-color: var(--roxo-claro, #772fa2);
  background-color: white;
}

.tipo-vaga-option input[type="radio"]:checked + .radio-custom::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--roxo-claro, #772fa2);
  animation: radioPop 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.tipo-vaga-option.selected {
  color: var(--roxo-claro, #772fa2);
  font-weight: 600;
}

@keyframes radioPop {
  0% {
    transform: translate(-50%, -50%) scale(0);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}

#datas {
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
}

#datas .field-group {
  flex: 1;
  min-width: 0;
}

.texto-informativo {
  height: 100%;
  resize: vertical;
}

.palavras-chave-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 2px solid var(--roxo-claro);
  border-radius: 5px;
  padding: 15px 5px 5px 5px;
}

.palavras-chave-form > .field-group {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  margin-bottom: 10px;
}

.keywords-tags {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  padding-bottom: 10px;
}

.palavra {
  border: 2px solid var(--roxo-claro);
  border-radius: 10px 0 10px 10px;
  padding: 2px 8px;
  margin-top: 10px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
}

.field-group > div > button {
  height: 100%;
  background-color: white;
  border-radius: 5px;
  border: 2px solid var(--roxo-claro);
  padding: 5px 10px;
}

.editor-wrapper {
  border: 2px solid var(--roxo-claro);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}

.editor-toolbar {
  display: flex;
  gap: 5px;
  padding: 8px;
  border-bottom: 1px solid var(--roxo-claro);
  background-color: #f9f9f9;
}

.toolbar-btn {
  height: 100%;
  background-color: white;
  border-radius: 5px;
  border: 1px solid var(--roxo-claro);
  padding: 5px 10px;
  cursor: pointer;
}

.toolbar-btn:hover {
  background-color: #e2e2e2;
}

.toolbar-btn.is-active {
  background-color: var(--roxo-claro, #dcdcdc);
  color: white;
  font-weight: bold;
}

.toolbar-divider {
  width: 1px;
  background-color: #ccc;
  margin: 0 5px;
}

:deep(.editor-textarea-tiptap .tiptap) {
  min-height: 200px;
  padding: 15px;
  outline: none;
  font-family: inherit;
  font-size: inherit;
}

:deep(.editor-textarea-tiptap .tiptap p) {
  margin: 0 0 1em 0;
}

/* Estilos de Upload de Imagem */
.file-upload {
  display: flex;
  align-items: center;
  border: 2px solid var(--roxo-claro);
  border-radius: 5px;
  overflow: hidden;
}

.btn-escolher {
  background: var(--roxo-claro);
  color: white;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.2s;
}

.btn-escolher:hover {
  background: #5b2484;
}

.file-name {
  padding: 8px 12px;
  font-size: 0.85rem;
  color: #666;
  flex: 1;
  background: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.image-preview-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.image-preview-img {
  max-width: 250px;
  max-height: 180px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-remover-img {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-remover-img:hover {
  background-color: #bd2130;
}
</style>
